import { render, staticRenderFns } from "./CatalogsPanel.vue?vue&type=template&id=12afd2cd&scoped=true&"
import script from "./CatalogsPanel.vue?vue&type=script&lang=js&"
export * from "./CatalogsPanel.vue?vue&type=script&lang=js&"
import style0 from "./CatalogsPanel.vue?vue&type=style&index=0&id=12afd2cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12afd2cd",
  null
  
)

export default component.exports